export default __webpack_public_path__ + "static/media/edit.c93b7440.svg";